import React, { useState, useRef } from "react";
import tree from "../Assets/tree2.svg";
import { Parallax, ParallaxProvider } from "react-scroll-parallax";
import emailjs from "@emailjs/browser";
import { MdCheckCircle, MdError } from "react-icons/md";
import { Helmet } from "react-helmet";

const ContactUs = () => {
  const form = useRef();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    message: "",
  });
  const [dialog, setDialog] = useState({
    type: "", // "success" or "error"
    message: "",
    show: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm("service_sru8dex", "template_4bp6zcd", form.current, {
        publicKey: "gMTXUWhgPfjikbc4W ",
      })
      .then(
        () => {
          showDialog("success", "Your message has been sent successfully!");
          setFormData({
            firstName: "",
            lastName: "",
            email: "",
            mobile: "",
            message: "",
          });
        },
        (error) => {
          showDialog(
            "error",
            "Failed to send the message. Please try again later."
          );
          console.error("FAILED...", error.text);
        }
      );
    console.log(formData);
  };

  const showDialog = (type, message) => {
    setDialog({ type, message, show: true });

    // Automatically close dialog after 3 seconds
    setTimeout(() => {
      setDialog({ ...dialog, show: false });
    }, 3000);
  };

  return (
    <ParallaxProvider>
      <Helmet>
        <title>Contact Montessori Preschool in Vellore | Admissions Enquiry</title>
        <meta name="description" content="Reach out to our Montessori Preschool & Play School in Vellore for Admissions, Program Details, and Daycare Enquiries. We’re Happy to Help." />
      </Helmet>

      <div className="">
        <div className="bg-[#f4f1ea] h-80 w-full">
          <div className="flex flex-col md:flex-row justify-between h-full pt-10 md:pt-20 pl-5 md:pl-28">
            <div className="w-full md:w-[40%] mt-8  space-y-3 ">
              <h1 className="text-[#0a3039] text-[#16bab1]xl md:text-[70px] font-bold navbar-link">
                Contact Us
              </h1>
              <p className="text-[#0a3039] text-base md:text-lg font-medium navbar-link">
                If you have any questions or inquiries please feel free to
                contact.
              </p>
            </div>
            <div className="w-full md:w-[50%] flex  justify-center md:justify-end mt-5 md:mt-0">
              <Parallax translateX={[35, -35]} className="">
                <img
                  src={tree}
                  alt="tree"
                  className="w-[200px] h-[180px] md:w-[370px] md:h-[330px]"
                />
              </Parallax>
            </div>
          </div>
        </div>
        <div className="wave rotate-180 -mt-16"></div>
        <div className="flex flex-wrap mx-auto w-[90%] navbar-link  p-4">
          <div className="w-full md:w-1/2 p-4 ">
            <div className="h-[500px] border border-gray-300 rounded overflow-hidden">
              <iframe
                title="Google Map Location"
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d62218.68001231835!2d79.0920587!3d12.9290792!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bad38e0201970e7%3A0x9ff44cc644ca9943!2sKalam%20Kids%20Kindergarten!5e0!3m2!1sen!2sin!4v1736243595285!5m2!1sen!2sin"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
          <div className="w-full md:w-1/2 p-4">
            <form
              ref={form}
              onSubmit={handleSubmit}
              className="flex flex-col space-y-4"
            >
              <div className="grid grid-cols-2 gap-4">
                <div className="flex flex-col space-y-2">
                  <label
                    htmlFor="firstName"
                    className="text-[#0a3039] font-medium"
                  >
                    First Name
                  </label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    placeholder="First Name"
                    value={formData.firstName}
                    onChange={handleChange}
                    className="p-2 border border-gray-300 rounded"
                    required
                  />
                </div>
                <div className="flex flex-col space-y-2">
                  <label
                    htmlFor="lastName"
                    className="text-[#0a3039] font-medium"
                  >
                    Last Name
                  </label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    placeholder="Last Name"
                    value={formData.lastName}
                    onChange={handleChange}
                    className="p-2 border border-gray-300 rounded"
                    required
                  />
                </div>
              </div>
              <div className="flex flex-col space-y-2">
                <label htmlFor="email" className="text-[#0a3039] font-medium">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                  className="p-2 border border-gray-300 rounded"
                  required
                />
              </div>
              <div className="flex flex-col space-y-2">
                <label htmlFor="mobile" className="text-[#0a3039] font-medium">
                  Mobile Number
                </label>
                <input
                  type="tel"
                  id="mobile"
                  name="mobile"
                  placeholder="Mobile Number"
                  value={formData.mobile}
                  onChange={handleChange}
                  className="p-2 border border-gray-300 rounded"
                  required
                />
              </div>
              <div className="flex flex-col space-y-2">
                <label htmlFor="message" className="text-[#0a3039] font-medium">
                  Your Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  placeholder="Your Message"
                  value={formData.message}
                  onChange={handleChange}
                  className="p-2 border border-gray-300 rounded"
                  rows="4"
                  required
                />
              </div>
              <button
                type="submit"
                className="bg-[#16bab1] text-white p-2 rounded hover:bg-[#d43f20] transition duration-200"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
        {dialog.show && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white p-6 rounded shadow-lg text-[#16bab1]enter w-[90%] max-w-sm">
              {dialog.type === "success" ? (
                <MdCheckCircle className="text-green-500 mx-auto mb-3" size={48} />
              ) : (
                <MdError className="text-red-500 mx-auto mb-3" size={48} />
              )}
              <p className="text-lg navbar-link font-semibold text-gray-800">
                {dialog.message}
              </p>
            </div>
          </div>
        )}
      </div>
    </ParallaxProvider>
  );
};

export default ContactUs;

